exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".invalid-cell {\n    background-color: red;\n    color: white;\n}\n", ""]);

